import Vue from 'vue/dist/vue.esm.js'
Vue.component('modal', {
  props: ["big"],
  template: JST['modal']()
})
